export default {
  en: {
    'pages.gameChanger.title': 'Game Changer',
    'pages.gameChanger-actions.step':
      'Step 2: Convert the text file into a compliance report per jurisdiction.',
    'pages.gameChanger-actions.process': 'process',
    'pages.gameChanger-actions.distanceSales': 'Run Distance Sales',
    'pages.gameChanger-actions.viewRequests': 'View Requests',
    'pages.gameChanger-actions.close': 'Close',
    'pages.gameChanger-actions.distanceSelling': 'Distance selling',
    'pages.gameChanger-actions.countries':
      'Please select countries considered as distance selling destination:',
    'pages.gameChanger-actions.all': 'All',
    'pages.gameChanger-actions.none': 'None',
    'pages.gameChanger-actions.run': 'Run',
    'pages.gameChanger-actions.cancel': 'Cancel',
    'pages.gameChanger-actions.reProcess': 'Re-process',
    'pages.gameChanger-actions.dataProcessing':
      "Data processing may take up to 20 minutes for large datasets but it's usually much faster.",
    'pages.gameChanger-actions.refresh': 'Please refresh the page after this period.',
    'pages.gameChanger-actions.continue': 'Continue',
    'pages.gameChanger-actions.import': 'Please import data first',
    'pages.gameChanger-outputFiles.delete': 'Are you sure you want to delete the file?',
    'pages.gameChanger-outputFiles.reProcess': 'Re-process',
    'pages.gameChanger-outputFiles.filter-by-jurisdiction': 'Filter by jurisdiction',
    'pages.gameChanger-outputFiles.filter-by-month': 'Filter by month',
    'pages.gameChanger-outputFiles.step': 'Step 3: Download compliance report per jurisdiction.',
    'pages.gameChanger-outputFiles.filter-by-compliance-status.non-compliant': 'non-compliant',
    'pages.gameChanger-outputFiles.filter-by-compliance-status.compliant': 'compliant',
    'pages.gameChanger-outputFiles.filter-by-compliance-status.all': 'all',
    'pages.gameChanger-outputFiles.filter-by-compliance-status.label': 'Compliance status',
    'pages.gameChanger.step':
      'Step 1: Make sure your transactions data has been imported from Amazon',
    'pages.gameChanger.draft-return': 'Add to draft return',
    'pages.gameChanger.import': 'Import',
    'pages.gameChanger.req-history.error.no-amazon-data':
      'No data available according to Amazon Seller Central',
    'pages.gameChanger.req-history.error.amazon-server-error': 'Server error from Amazon',
    'pages.gameChanger.req-history.error.game-changer': 'Error, please refresh page',
    'pages.gameChanger.transactions.refresh-message':
      'Please allow up to 20 minutes to pull the data and refresh this page.',
    'pages.gameChanger.transactions.amazon-pull-failed-message':
      'API Key invalid, Please update the API Key to use this function',
    'pages.gameChanger.transactions.process-request': 'Processing your request. Please wait.',
    'pages.gameChanger.transactions.missing': 'Missing',
    'pages.gameChanger.transactions.available': 'Transactions available',
    'pages.gameChanger.shipments.available': 'Shipments available',
    'pages.gameChanger.transactions.pull': 'PULL',
    'pages.gameChanger.transactions.overwrite.modal.heading.month':
      'The transaction data for the month of <b>{month}</b> already exists. Are you sure you wish to overwrite this data with a manual upload?',
    'pages.gameChanger.transactions.overwrite.modal.transaction.no-history': 'No history found!',
    'pages.gameChanger.transactions.overwrite.modal.transaction.title': 'Request History',
    'pages.gameChanger.no.output-files': 'No output files',
    'pages.gameChanger.output-files.created': 'Created: {date} at {time}',
    'pages.gameChanger-ecommerce.complete': 'Complete',
    'pages.gameChanger.request.created-at': 'Created at',
    'pages.gameChanger.request.data-type': 'Data Type',
    'pages.gameChanger.request.year': 'Year',
    'pages.gameChanger.request.month': 'Month',
    'pages.gameChanger.request.status': 'Status',
    'pages.gameChanger.request.message': 'Message',
    'pages.game-changer.api-details.update-details': 'Update Details',
    'pages.game-changer.api-details.error': 'Unexpected Error Occurred. Please try again later.',
    'pages.game-changer.distance-threshold': 'Distance Sales Threshold',
  },
};
